<template>
  <v-container>
    <v-row
      align="start"
      justify="start"
    >
      <v-col xs="12" md="6">
          <div v-if="usagePage === 'api'">
            <Api />
          </div>
          <div v-if="usagePage === 'url'">
            <Url />
          </div>
          <div v-if="usagePage === 'jsApi'">
            <JsApi :key="usagePage" />
          </div>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Api from '@/components/Api'
import Url from '@/components/Url'
import JsApi from '@/components/JsApi'

export default {
  name: 'Usage',
  components: {
    Api,
    Url,
    JsApi
  },
  methods: {
    ...mapMutations([
      'setUsagePage'
    ])
  },
  computed: {
    ...mapState({
      usagePage: ({ config }) => config.usagePage
    })
  }
}
</script>

<style>

</style>
